export const terms: any[] = [
  {
    Id: 0,
    Label: "Full Session"
  },
  {
    Id: 1,
    Label: "1st"
  },
  {
    Id: 2,
    Label: "2nd"
  },
  {
    Id: 3,
    Label: "3rd"
  },
];